import { h, defineAsyncComponent, type Component } from 'vue';

import PopoverModal from '@/components/modals/vfm/PopoverModal.vue';
import { VFMHelper } from '@/helpers/vfm/vfm-helper';
import { PopoverOptions } from '@/helpers/vfm/types';

const create = async ({ popoverProps, component, componentProps, onSlot, ...props }: PopoverOptions) => {
	await VFMHelper.ensureVfmCss();

	const resolvedComponent =
		typeof component === 'function' ? defineAsyncComponent(component as () => Promise<any>) : component;

	const { promise, dismiss } = VFMHelper.open({
		type: 'popover',
		slotComponent: {
			render() {
				return h(PopoverModal as any, popoverProps ?? {}, {
					default: () =>
						h(resolvedComponent as Component, { ...componentProps, onDismiss: dismiss, ...(onSlot ?? {}) }),
				});
			},
		},
		...props,
	});

	return promise;
};

export const PopoverHelper = {
	create,
};
